module.exports = __webpack_public_path__ + "media/images/header-banner-fba0c8c149c844bbf4deb0a199edc6f2.jpg";